import { useState, useMemo, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";

// Buscador de contenido del sitio público: páginas del landing, entradas del
// blog y productos de la tienda. Usa un índice curado de las rutas navegables
// más relevantes; filtra en vivo por título o etiqueta conforme escribes y
// navega al resultado al hacer clic. Pensado para vivir en el footer del
// landing y unificar el descubrimiento de contenido.
export const INDEX = [
  // Landing / plataforma
  { t: "Cotizar envío", to: "/cotizar", g: "Plataforma" },
  { t: "Cómo funciona", to: "/#como-funciona", g: "Plataforma" },
  { t: "Beneficios", to: "/#beneficios", g: "Plataforma" },
  { t: "Precios", to: "/#precios", g: "Plataforma" },
  { t: "Iniciar sesión", to: "/login", g: "Plataforma" },
  { t: "Crear cuenta", to: "/register", g: "Plataforma" },
  { t: "Corporativo", to: "/corporativo", g: "Plataforma" },
  // Recursos
  { t: "Guías y recursos", to: "/recursos", g: "Recursos" },
  { t: "Comparar paqueterías", to: "/comparar-paqueterias", g: "Recursos" },
  { t: "Agregadores", to: "/agregadores", g: "Recursos" },
  { t: "Zonas postales", to: "/zonas-postales", g: "Recursos" },
  { t: "Envíos internacionales", to: "/envios-internacionales", g: "Recursos" },
  { t: "Cotización en tiempo real", to: "/cotizacion-en-tiempo-real", g: "Recursos" },
  { t: "Rastreo centralizado", to: "/rastreo-centralizado", g: "Recursos" },
  { t: "Recolección agendable", to: "/recoleccion-agendable", g: "Recursos" },
  { t: "Saldo prepago", to: "/saldo-prepago", g: "Recursos" },
  { t: "Calculadora volumétrica", to: "/calculadora-volumetrica", g: "Recursos" },
  // Carriers
  { t: "DHL", to: "/paqueterias/dhl", g: "Carriers" },
  { t: "FedEx", to: "/paqueterias/fedex", g: "Carriers" },
  { t: "Estafeta", to: "/paqueterias/estafeta", g: "Carriers" },
  { t: "Paquetexpress", to: "/paqueterias/paquetexpress", g: "Carriers" },
  { t: "UPS", to: "/paqueterias/ups", g: "Carriers" },
  { t: "J&T Express", to: "/paqueterias/jt", g: "Carriers" },
  // Blog
  { t: "Blog", to: "/blog", g: "Blog" },
  { t: "El agregador de agregadores", to: "/blog/el-agregador-de-agregadores", g: "Blog" },
  { t: "SEO logístico en México", to: "/blog/seo-logistico-mexico", g: "Blog" },
  { t: "Plataformas de envío en México", to: "/blog/plataformas-de-envio-mexico", g: "Blog" },
  { t: "Marca blanca logística white label", to: "/blog/marca-blanca-logistica-white-label", g: "Blog" },
  { t: "Franquicia logística SaaS", to: "/blog/franquicia-logistica-saas", g: "Blog" },
  { t: "IA, Copilot y Gemini en logística", to: "/blog/ia-copilot-gemini-logistica", g: "Blog" },
  // Tienda
  { t: "Tienda online", to: "/tienda", g: "Tienda" },
  // Modelos de negocio
  { t: "Planes SaaS", to: "/planes-saas", g: "Modelos" },
  { t: "Franquicia logística", to: "/franquicia", g: "Modelos" },
  { t: "Autor", to: "/autor", g: "Modelos" },
  { t: "IA integradas", to: "/ia-integradas", g: "Modelos" },
  { t: "Cotizador con IA", to: "/cotizador-con-ia", g: "Modelos" },
  { t: "Rastreadores integrados API", to: "/rastreadores-integrados-api", g: "Modelos" },
  { t: "Conexiones API Maps", to: "/conexiones-api-maps", g: "Modelos" },
  { t: "Servicio de protección Cudo", to: "/seguro-adicional-cudo", g: "Modelos" },
  { t: "Plugin WooCommerce", to: "/plugin-woocommerce", g: "Integraciones" },
  { t: "Integración TiendaNube", to: "/integracion-tiendanube", g: "Integraciones" },
  { t: "Integración Shopify", to: "/integracion-shopify", g: "Integraciones" },
  { t: "API REST de envíos", to: "/api-rest", g: "Integraciones" },
  // Legal / soporte
  { t: "Centro de Ayuda", to: "/ayuda", g: "Soporte" },
  { t: "Términos y condiciones", to: "/terminos", g: "Legal" },
  { t: "Aviso de privacidad", to: "/privacidad", g: "Legal" },
  { t: "Políticas de envío", to: "/politicas-envio", g: "Legal" },
  // Corporativo
  { t: "Quiénes Somos", to: "/info/quienes-somos", g: "Corporativo" },
  { t: "Misión, Visión y Valores", to: "/info/mision-vision-valores", g: "Corporativo" },
  { t: "Cobertura Nacional e Internacional", to: "/info/cobertura", g: "Corporativo" },
  { t: "Aliados Logísticos", to: "/info/aliados-logisticos", g: "Corporativo" },
  { t: "Bolsa de Trabajo", to: "/info/bolsa-de-trabajo", g: "Corporativo" },
  { t: "Prensa y Medios", to: "/info/prensa", g: "Corporativo" },
  { t: "Contacto Corporativo", to: "/info/contacto-corporativo", g: "Corporativo" },
  // Legal ampliado
  { t: "Política de Cookies", to: "/legal/cookies", g: "Legal" },
  { t: "Tratamiento de Datos Personales", to: "/legal/tratamiento-datos", g: "Legal" },
  { t: "Política Anti-Spam", to: "/legal/anti-spam", g: "Legal" },
  { t: "Cumplimiento Normativo", to: "/legal/cumplimiento", g: "Legal" },
  { t: "Propiedad Intelectual", to: "/legal/propiedad-intelectual", g: "Legal" },
  { t: "Código de Ética y Conducta", to: "/legal/codigo-etica", g: "Legal" },
  // Políticas de envío
  { t: "Empaque y Embalaje", to: "/envios/empaque-embalaje", g: "Envíos" },
  { t: "Mercancías Frágiles", to: "/envios/fragiles", g: "Envíos" },
  { t: "Mercancías de Alto Valor", to: "/envios/alto-valor", g: "Envíos" },
  { t: "Documentos Oficiales", to: "/envios/documentos-oficiales", g: "Envíos" },
  { t: "Mercancías Perecederas", to: "/envios/perecederos", g: "Envíos" },
  { t: "Baterías de Litio y Electrónicos", to: "/envios/baterias-litio", g: "Envíos" },
  { t: "Servicio de Protección de Envíos", to: "/envios/seguros", g: "Envíos" },
  // Responsabilidad y reclamaciones
  { t: "Limitación de Responsabilidad", to: "/reclamaciones/limitacion-responsabilidad", g: "Reclamaciones" },
  { t: "Política de Indemnización", to: "/reclamaciones/indemnizacion", g: "Reclamaciones" },
  { t: "Política de Reclamaciones", to: "/reclamaciones/reclamaciones", g: "Reclamaciones" },
  { t: "Daños y Pérdidas", to: "/reclamaciones/danos-perdidas", g: "Reclamaciones" },
  { t: "Devoluciones y Retornos", to: "/reclamaciones/devoluciones", g: "Reclamaciones" },
  { t: "Resolución de Controversias", to: "/reclamaciones/controversias", g: "Reclamaciones" },
  { t: "Exclusión de Garantías", to: "/reclamaciones/exclusion-garantias", g: "Reclamaciones" },
  // Plataforma y tecnología
  { t: "Condiciones de Uso de la Plataforma", to: "/plataforma/condiciones-uso", g: "Plataforma" },
  { t: "Condiciones API", to: "/plataforma/condiciones-api", g: "Plataforma" },
  { t: "Términos para Integradores", to: "/plataforma/terminos-integradores", g: "Plataforma" },
  { t: "Seguridad de la Información", to: "/plataforma/seguridad-informacion", g: "Plataforma" },
  { t: "Política de Ciberseguridad", to: "/plataforma/ciberseguridad", g: "Plataforma" },
  { t: "Disponibilidad del Servicio (SLA)", to: "/plataforma/sla", g: "Plataforma" },
  { t: "Política de Uso Aceptable", to: "/plataforma/uso-aceptable", g: "Plataforma" },
  // Clientes y usuarios
  { t: "Registro y Verificación de Cuenta", to: "/clientes/registro-verificacion", g: "Clientes" },
  { t: "Política KYC", to: "/clientes/kyc", g: "Clientes" },
  { t: "Política Antifraude", to: "/clientes/antifraude", g: "Clientes" },
  { t: "Política de Cancelación", to: "/clientes/cancelacion", g: "Clientes" },
  { t: "Política de Reembolsos", to: "/clientes/reembolsos", g: "Clientes" },
  { t: "Política de Métodos de Pago", to: "/clientes/metodos-pago", g: "Clientes" },
  { t: "Política de Facturación CFDI", to: "/clientes/facturacion-cfdi", g: "Clientes" },
  // Proveedores
  { t: "Términos para Proveedores", to: "/proveedores/terminos", g: "Proveedores" },
  { t: "Requisitos de Afiliación", to: "/proveedores/afiliacion", g: "Proveedores" },
  { t: "Política de Calidad de Servicio", to: "/proveedores/calidad", g: "Proveedores" },
  { t: "Acuerdos de Nivel de Servicio", to: "/proveedores/ans", g: "Proveedores" },
  { t: "Régimen de Responsabilidad de Terceros", to: "/proveedores/responsabilidad-terceros", g: "Proveedores" },
];

export default function FooterSearcher() {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onClick = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const results = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return [];
    return INDEX.filter(it => it.t.toLowerCase().includes(term) || it.g.toLowerCase().includes(term)).slice(0, 8);
  }, [q]);

  const go = (to) => {
    setQ("");
    setOpen(false);
    if (to.startsWith("/#")) {
      navigate("/");
      setTimeout(() => {
        const id = to.slice(2);
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 60);
    } else {
      navigate(to);
    }
  };

  return (
    <div ref={boxRef} className="relative max-w-xl">
      <div className="flex items-center gap-2 surface-inset px-3 py-2.5 focus-within:border-cyan transition-colors">
        <Search className="w-4 h-4 text-ink-muted shrink-0" />
        <input
          type="text"
          value={q}
          onChange={(e) => { setQ(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          placeholder="Buscar en la plataforma, blog, tienda y legal…"
          className="flex-1 bg-transparent outline-none text-sm text-ink-text placeholder:text-ink-muted/70"
          aria-label="Buscar contenido"
        />
        {q && (
          <button onClick={() => { setQ(""); setOpen(false); }} aria-label="Limpiar" className="text-ink-muted hover:text-cyan">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      {open && results.length > 0 && (
        <div className="absolute left-0 right-0 top-full mt-1 surface z-50 max-h-80 overflow-y-auto overscroll-contain shadow-2xl">
          {results.map((r) => (
            <button
              key={r.to + r.t}
              type="button"
              onClick={() => go(r.to)}
              className="w-full flex items-center justify-between gap-3 px-3 py-2.5 text-left hover:bg-cyan/10 transition-colors border-b border-ink-border/60 last:border-0"
            >
              <span className="text-sm text-ink-text truncate">{r.t}</span>
              <span className="text-[0.6rem] uppercase tracking-wider text-cyan shrink-0">{r.g}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}